<template>
  <b-container style="margin-left: 5px" id="pdfQuestions">
    <ckeditor :style="getPageTitleColor(pageAccentColor)" :editor="editor" v-model="pageName" :config="editorConfig"
              :disabled="true"></ckeditor>
    <ckeditor class="verbiage" :editor="editor" v-model="text" :config="editorConfig" :disabled="true"></ckeditor>

    <div id="core-title-bar" class="survey-title">
      <div class='core_measure_header' :style="`background-color:${pageAccentColor}`" v-if="coreQuestions.length"><h3
          style='margin-left: 5px;'>CORE MEASURES</h3></div>
    </div>
    <VineyardQuestion v-for="question in coreQuestions" :key="question._id" :q-value="question"
                      :response="getAnswer(question)"></VineyardQuestion>
    <div id="elective-title-bar" class="survey-title">
      <div class='core_measure_header' :style="`background-color:${pageAccentColor}`" v-if="electiveQuestions.length">
        <h3 style='margin-left: 5px;'>ELECTIVE
          MEASURES ({{ requiredElective + " of " + electiveQuestions.length }} Required)</h3></div>
    </div>
    <VineyardQuestion v-for="question in electiveQuestions" :key="question._id" :q-value="question"
                      :response="getAnswer(question)"></VineyardQuestion>
    <div id="comments-title-bar" class="survey-title">
      <VineyardQuestion :key="`${pageId}-comment`" v-if="inputPage"
                        :q-value="{qnum:'*', text:'Comments', controlType: 'COMMENT', _id : pageId+'Comment'}"
                        :response="getCommentResponse"></VineyardQuestion>
    </div>
    <div style="margin-top: 20px; margin-left: auto"></div>
  </b-container>
</template>
<script>
import VineyardQuestion from "@/components/vineyard/questions/VineyardQuestion";
import InlineEditor from "@ckeditor/ckeditor5-editor-inline/src/inlineeditor";
import Bus from "@/eventBus";
import CKEditor from "@ckeditor/ckeditor5-vue2";
import ListPlugin from "@ckeditor/ckeditor5-list/src/list";
import HtmlEmbed from "@ckeditor/ckeditor5-html-embed/src/htmlembed";
import BlockQuotePlugin from "@ckeditor/ckeditor5-block-quote/src/blockquote";
import EssentialsPlugin from "@ckeditor/ckeditor5-essentials/src/essentials";
import BoldPlugin from "@ckeditor/ckeditor5-basic-styles/src/bold";
import ItalicPlugin from "@ckeditor/ckeditor5-basic-styles/src/italic";
import LinkPlugin from "@ckeditor/ckeditor5-link/src/link";
import ParagraphPlugin from "@ckeditor/ckeditor5-paragraph/src/paragraph";
import Table from '@ckeditor/ckeditor5-table/src/table.js';
import TableToolbar from '@ckeditor/ckeditor5-table/src/tabletoolbar.js';
import Image from '@ckeditor/ckeditor5-image/src/image.js';
import ImageInsert from "@ckeditor/ckeditor5-image/src/imageinsert";
import TodoList from '@ckeditor/ckeditor5-list/src/todolist';
import TableProperties from "@ckeditor/ckeditor5-table/src/tableproperties";
import FontBackgroundColor from "@ckeditor/ckeditor5-font/src/fontbackgroundcolor";
import FontColor from "@ckeditor/ckeditor5-font/src/fontcolor";

export default {
  name: 'vineyard-survey-page',
  components: {
    VineyardQuestion,
    'ckeditor': CKEditor.component
  },
  props: {
    pageId: String,
    answers: {}
  },
  data() {
    return {
      coreQuestions: [],
      electiveQuestions: [],
      commentsText: "",
      pageName: "SOCIAL EQUITY JUSTICE & INCLUSION",
      answersList: this.answers,
      text: "",
      inputPage: false,
      pageBackgroundColor: 'rgb(248, 248, 248)',
      pageAccentColor: 'blue',
      requiredElective: 0,
      editorConfig: {
        link: {
          addTargetToExternalLinks: true
        },
        isReadOnly: true,
        plugins: [
          EssentialsPlugin,
          BoldPlugin,
          ItalicPlugin,
          LinkPlugin,
          ParagraphPlugin,
          ListPlugin,
          HtmlEmbed,
          BlockQuotePlugin,
          Table,
          TableToolbar,
          TableProperties,
          Image,
          ImageInsert,
          TodoList,
          FontBackgroundColor,
          FontColor
        ],
        toolbar: {
          items: [
            'heading',
            '|',
            'bold',
            'italic',
            'link',
            'fontColor',
            'paragraph',
            'bulletedList',
            'numberedList',
            '|',
            'outdent',
            'indent',
            '|',
            'imageUpload',
            'imageInsert',
            'htmlEmbed',
            'blockQuote',
            'horizontalLine',
            'insertTable',
            'mediaEmbed',
            'undo',
            'redo',
            'image',
            'todoList'
          ]
        },
        language: 'en',
        image: {
          toolbar: [
            'imageTextAlternative',
            'imageStyle:full',
            'imageStyle:side'
          ]
        },
        table: {
          contentToolbar: [
            'tableColumn',
            'tableRow',
            'mergeTableCells'
          ]
        },
        fontColor: {
          colors: [
            {
              color: 'hsl(0, 0%, 0%)',
              label: 'Black'
            },
            {
              color: 'hsl(0, 0%, 30%)',
              label: 'Dim grey'
            },
            {
              color: 'hsl(0, 0%, 60%)',
              label: 'Grey'
            },
            {
              color: 'hsl(0, 0%, 90%)',
              label: 'Light grey'
            },
            {
              color: 'hsl(0, 0%, 100%)',
              label: 'White',
              hasBorder: true
            },
            {
              color: '#28763a',
              label: "Introduction"
            },
            {
              color: '#3b5152',
              label: "SOCIAL EQUITY, JUSTICE AND INCLUSION"
            },
            {
              label: "IRRIGATION ASSESSMENTS & WATER EFFICIENCY",
              color: "#1F497D"
            }
          ],
          columns: 6
        }
      },
      editor: InlineEditor
    }
  },
  mounted() {
    let self = this;
    this.$http.get(`vineyard/survey/page/${this.pageId}`)
        .then(result => {
          let checklistPage = result.data;
          self.text = checklistPage.verbiage;
          self.coreQuestions = checklistPage.coreQuestions;
          self.electiveQuestions = checklistPage.electiveQuestions;
          self.commentsText = this.answers[`${this.pageId}Comment`];
          self.inputPage = checklistPage.inputPage;
          self.pageName = checklistPage.name;
          self.requiredElective = checklistPage.requiredElective;
          self.pageBackgroundColor = checklistPage.pageBackgroundColor || self.pageBackgroundColor;
          self.pageAccentColor = checklistPage.pageAccentColor;
          console.log("Changing Background Color To: " + self.pageBackgroundColor);
          Bus.$emit('vineyard-page-background-update', self.pageBackgroundColor);
          self.$store.commit('survey/activeSectionId', checklistPage.section);
          /****************************************************/
          if (this.$route.query.debug === "true") {
            console.log("Answers List");
            console.log(this.answersList);
            if (this.coreQuestions.length > 0) {
              console.log("Core Questions");
              console.log(this.coreQuestions[0])
              console.log(this.answersList[this.coreQuestions[0]._id]);
            }
            console.log(this.commentsText);
            console.log("Input Page: " + this.inputPage);
          }
        })
        .catch(error => {
          console.log(error)
        });
  },
  watch: {
    pageId: function (val) {
      let self = this;
      this.$http.get(`vineyard/survey/page/${this.pageId}`)
          .then(result => {
            console.log(`Page Id: ${val}`);

            let page = result.data;
            self.text = page.verbiage;
            self.electiveQuestions = page.electiveQuestions;
            self.coreQuestions = page.coreQuestions;
            self.commentsText = page.commentsText;
            self.inputPage = page.inputPage;
            self.pageName = page.name;
            self.requiredElective = page.requiredElective;
            self.pageBackgroundColor = page.pageBackgroundColor || self.pageBackgroundColor;
            self.pageAccentColor = page.pageAccentColor;
            console.log("Changing Background Color To: " + self.pageBackgroundColor);
            Bus.$emit('vineyard-page-background-update', self.pageBackgroundColor);
            self.$store.commit('survey/activeSectionId', page.section);
          })
          .catch(error => {
            console.log("Error: " + error.message);
          })
      console.log("Updating commentsText");
      self.commentsText = this.answers[`${this.pageId}Comment`];
    }
  },
  computed: {
    getCommentResponse() {
      return this.answers[this.pageId + 'Comment'];
    }
  },
  methods: {
    getPageTitleColor: function (pageAccentColor) {
      return `color: ${pageAccentColor}; margin-left: 5px;font-size: 32px;font-family: Montserrat, sans-serif;text-transform: capitalize;`;
    },
    parseCheckboxAnswer: function (answer) {
      try {
        return answer ? JSON.parse(answer) : [];
      } catch (err) {
        console.log(`Unable to parse checkbox answer with err: [${err.message}] and answer content: [${answer}]`)
      }
      return [];
    }, getAnswer: function (question) {
      let answer = this.answers[question._id];
      if (question.controlType === "CHECKBOX") {
        if (Array.isArray(answer)) {
          return answer;
        } else {
          return this.parseCheckboxAnswer(answer);
        }
      }
      return answer
    },
    reportCommentValue: function (event) {
      console.log(event);
      Bus.$emit('measure-answer-update', this.pageId + "Comment",
          document.getElementById(this.pageId + "-comment").value);
    }
  }
}
</script>
<style scoped>

.verbiage >>> a:link {
  color: #28763a;
}

.core_measure_header {
  /*color: rgb(222, 119, 43);*/
  color: white;
}

.survey-title {
  font-family: Montserrat, sans-serif, serif;
  padding-top: 15px;
}

/*font-size: 32 px;*/
.page-title {
  margin-left: 5px;
  font-size: 32px;
  font-family: Montserrat, sans-serif;
  text-transform: capitalize;
}

.text-section {
  max-width: 1000px;
  text-align: left;
  margin-left: 5px;
  font-size: 20px;
  font-family: Montserrat, sans-serif;
}
</style>
